import { toast } from "react-toastify";
import { fetchSetUpdatePasswordSucess, fetchSetUpdatePasswordFailure } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { UPDATE_PASSWORD_API } from "../../constants/constants";

export const UpdatePassword = (jsonObj, userId, setLoading, navigate,setPasswordCustomer, setPasswordModal) => async (dispatch, getState) => {
    try {
        setLoading(true);
        const response = await determineBaseUrlAndPerformApiCall(`${UPDATE_PASSWORD_API}/${userId}`, 'PUT', jsonObj);
        if (!response.error) {
            setLoading(false);
            dispatch(fetchSetUpdatePasswordSucess({response:response}));
            if (location.pathname.includes("view-operator")){
                navigate(`${location.pathname}`);
                setPasswordModal(false);
                toast.success(`Password configured successfully`);
            }
            else {
                navigate("/customer");
            }
            setPasswordCustomer(null);
        } else {
            dispatch(fetchSetUpdatePasswordFailure(response.error.message));
            setLoading(false);
            toast.error(`${response.error.message}`);
        }
    } catch (errorResp) { }
};
